const getHighlightedElements = (rootState) => rootState.ui.highlighter.elements;

export default getHighlightedElements;
